import { useCallback } from "react";
import { KICKOUT_CONDITION_ERROR_CODES } from "@newLayouts/auth/DocsAuthTokenManager";
import { useSessionContext } from "@newHooks/context/session/session.context";
import { RestError } from "@maven-rest/common/HttpRequest";

export interface SignOutOption {
  redirectTo?: string;
}

export const isInvalidCredential = (error: unknown) => {
  if (!error) {
    return false;
  }

  const hasStringErrorCode = (candidate: unknown): candidate is { code: string } => {
    if (typeof candidate !== "object" || candidate === null) {
      return false;
    }

    return "code" in candidate && typeof (candidate as Record<string, unknown>).code === "string";
  };

  // NOTE: Rest 기반 에러 응답
  if (error instanceof RestError) {
    return (
      KICKOUT_CONDITION_ERROR_CODES.includes(error.response?.responseCode) || KICKOUT_CONDITION_ERROR_CODES.includes(error.responseCode)
    );
  }

  // NOTE: Flax 기반 에러 응답
  if (hasStringErrorCode(error)) {
    return KICKOUT_CONDITION_ERROR_CODES.includes(error.code);
  }

  return false;
};

export const useSignOut = () => {
  const { onDeleteSession } = useSessionContext();

  const signOut = useCallback(
    (option?: SignOutOption) => {
      onDeleteSession();

      if (option?.redirectTo) {
        document.location.href = option.redirectTo;
      }
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onDeleteSession]
  );

  return signOut;
};
